import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BankingStatusDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-banking-status',
  templateUrl: './banking-status.component.html',
  styleUrls: ['./banking-status.component.scss']
})

export class BankingStatusComponent implements OnChanges {

  bankingstatusForm: FormGroup;
  bankingstatusFormArray: FormGroup;
  control = new FormControl();
  @Input() bankingstatuss: BankingStatusDto[];
  @Input() routeAnimationsElements: any;
  @Output() bankingstatus = new EventEmitter<BankingStatusDto[]>()
  @Output() deleteBankingStatusEvent = new EventEmitter<any>()

    selectedBankingStatus: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnChanges() {
      this.createBankingStatusForm();
    }

    createBankingStatusForm() {
      this.bankingstatusForm = this.fb.group({
        BankingStatusName: ['', Validators.required],
        id: null
        });
        this.bankingstatusFormArray = this.fb.group({ BankingStatuss: this.fb.array([])
          });
        this.setBankingStatus();
    }

  // method to display bankingstatuss
  setBankingStatus() {
    const control  = this.bankingstatusFormArray.controls.BankingStatuss as FormArray;
    this.bankingstatuss.forEach( e => {
      control.push(
        this.fb.group({
          BankingStatusName: e.BankingStatusName,
          id: e.id
        })
      );
    });
  }


  // method to add BankingStatus
  addBankingStatus(value: BankingStatusDto) {
    const control  = this.bankingstatusFormArray.controls.BankingStatuss as FormArray;
    control.insert(0,
          this.fb.group({
            BankingStatusName: value.BankingStatusName,
            id: null
          })
       );
  }

  selectBankingStatus(value) {}

  // method to delete bankingstatus from arrary list
  deleteBankingStatus(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.bankingstatusFormArray.controls.BankingStatuss as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.bankingstatuss.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.bankingstatuss[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: BankingStatusDto) {
    if(this.bankingstatusForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.bankingstatusFormArray.get('BankingStatuss')['controls'][this.selectedIndex].patchValue({BankingStatusName: formValue.BankingStatusName});
    } else {
      this.addBankingStatus(formValue);
    }
    this.selectedIndex = null;
    this.bankingstatusForm.reset()
  }

  onEdit(index, value: BankingStatusDto) {
    console.log(index, value)
    this.selectedIndex = index;
    this.bankingstatusForm.patchValue({BankingStatusName: value.BankingStatusName});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.bankingstatusForm.reset();
  }

  onSubmit(formValue: BankingStatusDto[]) {
  this.bankingstatus.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteBankingStatusEvent.emit(this.filteredDelete);
  }
  }

  
  }